import { getNotification } from "context/NotificationContext";

export const errorHandler = (error) => {
    if(!error || !error.details) return;
    error.details.forEach((item) => {
        const { message } = item;
        if(!message) return;
        getNotification()?.(message, "error");
    });
}